import React from 'react';
import { Main, MedianSymbol, MedianText, Sub } from './ChartLegend.styles';

const ChartLegend = () => {
	return (
		<Main>
			<Sub>
				<MedianText>Median</MedianText>
				<MedianSymbol />
			</Sub>
		</Main>
	);
};

export default ChartLegend;
